.topBar {
    --top-bar-edge-area: 6.5rem;
    position: relative;
    display: flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    padding-inline: var(--top-bar-edge-area);
    border-bottom: 1px solid var(--mantine-color-default-border);
    background-color: var(--mantine-color-body);
    min-height: 52px;
    box-sizing: border-box;
    flex-shrink: 0;
}

.topBar[data-icon-count="0"] {
    --top-bar-edge-area: 0.5rem;
}

.topBar[data-icon-count="1"] {
    --top-bar-edge-area: 4rem;
}

.left {
    position: absolute;
    left: var(--mantine-spacing-md);
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    z-index: 1;
}

.constrainer {
    width: 100%;
    max-width: var(--app-thread-width);
    margin-inline: auto;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    position: relative;
}

/* Slotted content marked data-fullbleed opts out of the thread-width
   constraint and handles its own max-width/centering (e.g. the checklist
   view tabs, which align with the wider checklist content below). */
.constrainer:has([data-fullbleed]) {
    max-width: none;
}

.center {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    min-width: 0;
    flex: 1;
}

.right {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
}

.iconButton {
    color: var(--mantine-color-gneis-9);
}

.iconButton:hover {
    background-color: var(--mantine-color-gneis-1);
}

.dashboardToggle {
    position: fixed;
    top: var(--mantine-spacing-sm);
    left: var(--mantine-spacing-sm);
    z-index: 1000;
}
